import React, { createContext, useContext, useState } from "react";
import AccountService from "../Services/accountService";

const PrivilegeContext = createContext();

export const PrivilegeProvider = ({ children }) => {
  const [pState, setPState] = useState(null);

  const privileges = async () => {
    if (!pState) {
      const p = await AccountService.GetPrivileges();
      setPState(p);
      return p;
    } else {
      return pState;
    }
  };

  return (
    <PrivilegeContext.Provider value={{ privileges, setPState }}>
      {children}
    </PrivilegeContext.Provider>
  );
};

export const usePrivileges = () => {
  const context = useContext(PrivilegeContext);
  if (!context) {
    throw new Error("usePrivileges must be used within a PrivilegeProvider");
  }
  return context;
};
